import { TCartContact } from '@providers/booking/types'
import { OrderClientDto, OrderPaymentClientDto } from 'service-api/src/types/api'

export const removeDecimal = (value?: string | number | null) => {
  if (!value) return 0
  const tmpN = Number(value)
  if (Number.isNaN(tmpN)) return 0
  return tmpN * 100
}

export const getBillingAddress = (cartContact: TCartContact) => {
  return {
    street: `${cartContact.mailingAddress.streetAddress} ${cartContact.mailingAddress.streetAddress2}`.trim(),
    postalCode: cartContact.mailingAddress.zipCode,
    city: cartContact.mailingAddress.city,
    country: cartContact.mailingAddress.country,
    stateOrProvince: cartContact.mailingAddress.state,
    houseNumberOrName: '',
  }
}

export const getDepositDue = (order: OrderClientDto | undefined) => {
  return (
    (order?.payments || []).reduce(
      (acc, payment) => acc + (payment.step === 'PENDING' ? (payment.depositDue ?? 0) : 0),
      0
    ) ?? 0
  )
}

export const paymentToConfirmOrCancel = (order: OrderClientDto | undefined) => {
  const payments = order?.payments || []
  const nonCanceledPayments = payments.filter((payment) => payment.step !== 'CANCELED')
  const lastPayment = nonCanceledPayments.at(-1) ?? null
  const voucherCashPayment = nonCanceledPayments.find((payment) => payment.payFacType === 'VOUCHER_CASH')
  const parentOfVoucherCash =
    voucherCashPayment?.parentPaymentId && nonCanceledPayments.length
      ? (nonCanceledPayments.find((payment) => payment.id === voucherCashPayment.parentPaymentId) ?? null)
      : null

  return parentOfVoucherCash || lastPayment || null
}

export const adyenPaymentToUse = (order: OrderClientDto | undefined) => {
  return order?.payments?.find((p) => p.step === 'PENDING' && p.payFacType === 'ADYEN')
}

export const isPaymentInitialized = (payment: OrderPaymentClientDto) => {
  return payment.payFacType !== undefined && payment.payFacType !== null
}
